import React, { useState } from 'react'
import { AddCases } from './AddCases'
import AmzCasesTable from './AmzCasesTable'
import AppShell from '../../../Components/AppShell'
import PageHeader from '../../../Components/PageHeader'

const AmazonCases = () => {
  const [isAltered, setIsAltered] = useState(false)

  const handleAlterState = () => {
    setIsAltered((prevState) => !prevState)
  }

  return (
    <AppShell>
      <PageHeader
        kicker="Listings"
        title="Amazon Cases"
        subtitle="Monitor cases and open conversation threads."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Listings', to: '/listings-tools' },
          { label: 'Amazon Cases' },
        ]}
        actions={<AddCases onAlterState={handleAlterState} />}
        status={<span className="nx-chip-info">Monitoring</span>}
      />
      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <AmzCasesTable isAltereds={isAltered} />
      </div>
    </AppShell>
  )
}

export default AmazonCases
